import BaseMove from "./base-move";
import {ActionTypeEnum} from "../../base/training-literals";

class MoveModel extends BaseMove {
    modelId;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.MOVE_MODEL;
        this.modelId = props.modelId || "";
    }

    get(props = {}) {
        return {
            type: this.actionType,
            modelId: props.modelId || this.modelId,
            animateMovement: props.animateMovement || this.animateMovement,
            animateTime: props.animateTime || this.animateTime,
            position: props.position || this.position,
            quaternion: props.quaternion || this.quaternion,
            scale: props.scale || this.scale,
            duration: props.duration || this.duration
        }
    }

    startModelSelectionCallback(itemArr) {
        const actionId = itemArr[0];
        if (!this.shouldExecute(actionId)) return;

        this.startSelectionForMove();
    }

    startSelectionForMove() {
        this.startModelSelection = true;
        const applyToType = CatchTargetTypeEnum.MODEL;
        VRMessageController.addMessage({
            text: "Select a model to perform move model.",
            priority: VrMessagePriorityEnum.WARNING
        });

        super.startSelectionForMove(applyToType);
    }

    selectEntityForEditingMove(entityName) {
        entityName = entityName[0];
        this.cancelSelection = false;
        this.startModelSelection = true;
        this.set2dElementsVisibility(false);
        CatchVolumeFeatureController.onChangeMoveFeature(true);
        CatchVolumeFeatureController.onSelectApplyToType(CatchTargetTypeEnum.MODEL);
        catchModel(undefined, undefined, undefined, undefined, {modelId: entityName});
        this.startModelSelection = false;
    }

    sendDataOnCatchModel(caughtVolume) {
        MoveObjectActionController.modelId = caughtVolume.model.id;
        MoveObjectActionController.modelName = caughtVolume.modelName || caughtVolume.model_name;
    }

    getData() {
        const modelObj = getModelObject(MoveObjectActionController.modelId);
        modelObj.updateMatrixWorld(true);
        const currentModelMatrix = modelObj.matrix;
        const position = new THREE.Vector3();
        const quaternion = new THREE.Quaternion();
        const scale = new THREE.Vector3();
        currentModelMatrix.decompose(position, quaternion, scale);

        return {
            position: position.toArray(),
            quaternion: quaternion.toArray(),
            scale: scale.toArray()
        };
    }

    catchObjectToMove() {
        CatchVolumeFeatureController.onSelectApplyToType(CatchTargetTypeEnum.MODEL);
        catchModel(undefined, undefined, undefined, undefined,
            {
                modelName: MoveObjectActionController.modelName,
                modelId: MoveObjectActionController.modelId
            });
    }
}

export default MoveModel;